import { Box, Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import MotorPriceDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorPriceDetails'
import VehicleDetails from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetails'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useHistory } from 'react-router-dom'
import ContactUs from 'src/components/BuyPolicy/insuranceScreens/health/ContactUs'
import Claims from 'src/components/BuyPolicy/insuranceScreens/motor/PlanDetailsMotor/Claims'
import AddonsCoverage from 'src/components/BuyPolicy/insuranceScreens/motor/PlanDetailsMotor/AddonsCoverage'
import Covered from 'src/components/BuyPolicy/insuranceScreens/motor/PlanDetailsMotor/Covered'
import claimsTab from 'src/assets/viewPlanMotor/claimsTab.svg'
import featureTab from 'src/assets/viewPlanMotor/featureTab.svg'
import addOnsTab from 'src/assets/viewPlanMotor/addOnsTab.svg'
import { useSelector } from 'react-redux'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import BikeCoverageDetails from 'src/components/BuyPolicy/insuranceScreens/motor/PlanDetailsMotor/BikeCoverageDetails'

const ViewPlanDetailsMotor = () => {
  const history = useHistory()
  const classes = useStyles()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const vehicleType = motorDetails?.vehicleDetails?.vehicleType

  const handleBack = () => {
    history.goBack()
  }
  const scrollToComponent = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <Box className={classes.componentBackground}>
      <Box className={classes.componentElement}>
        <Box className={classes.containerMain}>
          <Grid container spacing={2} direction='column'>
            <Grid item xs={12}>
              <VehicleDetails isEdit={false} />
            </Grid>
            <Grid item container direction='row' spacing={2}>
              <Grid item xs={12} md={8.2}>
                <Box className={classes.userDetailsContainer}>
                  <Box>
                    <Box className={classes.conatinerBack} onClick={handleBack}>
                      <img src={BackArrow} alt='back-arrow-img' />
                      <Box className={classes.conatinerBackText}>
                        Go back to Quotes
                      </Box>
                    </Box>
                  </Box>
                  <Box>
                    <Box className={classes.userDetailsContainerText}>
                      Please check your Policy Details
                    </Box>
                  </Box>
                  <Box display={'flex'} flexDirection={'column'}>
                    <div className={classes.coverageTabContainer}>
                      <div
                        className={classes.coverageTab}
                        onClick={() => scrollToComponent('features')}
                        id='coverageTabScroll'
                      >
                        <img src={featureTab} /> Features
                      </div>
                      <div
                        className={classes.coverageTab}
                        onClick={() => scrollToComponent('addOns')}
                        id='coverageTabScroll'
                      >
                        <img src={addOnsTab} /> Addons
                      </div>
                      {vehicleType === VEHICLE_TYPE?.TWO_WHEELER ? null : (
                        <div
                          className={classes.coverageTab}
                          onClick={() => scrollToComponent('claims')}
                          id='coverageTabScroll'
                        >
                          <img src={claimsTab} /> Claims
                        </div>
                      )}
                    </div>
                    <Box id='features'>
                      {vehicleType === VEHICLE_TYPE?.TWO_WHEELER ? (
                        <BikeCoverageDetails />
                      ) : (
                        <Covered />
                      )}
                    </Box>
                    <Box id='addOns'>
                      <AddonsCoverage />
                    </Box>
                    {vehicleType === VEHICLE_TYPE?.TWO_WHEELER ? null : (
                      <Box id='claims'>
                        <Claims />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={3.8}>
                <MotorPriceDetails />
                <Box className={classes.contactSection}>
                  <ContactUs color='linear-gradient(142.32deg, #4DC3E3 -476.58%, #FFFFFF 81.03%)' />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default ViewPlanDetailsMotor

const useStyles = makeStyles({
  containerMain: {
    padding: '10px 10px 60px 10px',
    background: 'linear-gradient(180deg, #DFF7FF 0.08%, #FFFFFF 105.47%)',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  userDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 10,
  },
  conatinerBack: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    cursor: 'pointer',
  },
  conatinerBackText: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '0.9375em',
    letterSpacing: '0em',
    color: '#3E3E3E',
  },
  userDetailsContainerText: {
    fontFamily: 'Roboto',
    fontSize: '1.125em',
    fontWeight: 500,
    lineHeight: '1.6875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  userDetailsContainerTextSecondary: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '1.25em',
    letterSpacing: '0em',
    color: '#7C7C7C',
  },
  componentElement: {
    maxWidth: '1240px !important',
    width: '100%',
    padding: '10px 0px 10px 0px',
  },
  componentBackground: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },
  contactSection: {
    padding: '20px',
  },
  coverageTabContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 30px',
    borderBottom: '1px solid #C7C7C7',
    width: '92%',
  },
  coverageTab: {
    padding: '10px 20px !important',
    cursor: 'pointer !important',
    '&:hover': {
      color: '#1EA8CE !important',
      textTransform: 'unset !important',
      borderBottom: '3px solid #1EA8CE !important',
    },
    fontSize: '15px !important',
    fontWeight: '600 !important',
    color: '#000000 !important',
  },
})
